import TreeBackground from "graphics/icons/TreeBackground";
import TreeBackgroundSecond from "graphics/icons/TreeBackgroundSecond";
import React, { useEffect, useState } from "react";
const maxRadius = 700;
const TreeAnimate = () => {
  const [radius, setRadius] = useState(160);

  useEffect(() => {
    setTimeout(() => {
      setRadius(maxRadius);
    }, 20);
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <div
        className="tree-animate-container"
        style={{ height: radius * 2 + "px", width: radius * 2 + "px" }}
      >
        <div className="tree-animate-container-inner">
          <TreeBackgroundSecond />
        </div>
      </div>
      <div
        className="tree-animate-container second"
        style={{ height: radius * 2 + "px", width: radius * 2 + "px" }}
      >
        <div className="tree-animate-container-inner">
          <TreeBackground />
        </div>
      </div>
    </>
  );
};

export default TreeAnimate;
